module.exports = __webpack_public_path__ + "img/freewave1_03.3f3961c7.jpg";